import {guard, IMAGE_FORMAT} from 'acng/model';
import {AttributeLink} from '@acng/frontend-stargazer';

/**
 * @group DOM Attribute
 */
const name = 'image-format';

ASSERT: {
  AttributeLink(name, (element, value) => {
    guard(value, IMAGE_FORMAT, `[${name}=${value}]`);
  });
}

export {name as IMAGE_FORMAT};
